import React from 'react'
import "./Loder.css"

const Forfmsubmit = () => {
    return (
        <>
            <div className="loader">
                <div className="loader-maindiv"></div>
                <div className="loader-underdiv"></div>
                <p>Submitting...</p>
            </div>
        </>
    )
}

export default Forfmsubmit
